<template>
  <div class="component-subTabPage">
    <!-- 筛选组件 -->
    <FilterView ref="filterView" v-show="pageType === 'cate' && goodsListData.total_count > 0" @change="handleChangeSort" />
    <!-- 骨架屏 -->
    <div class="skeleton-list" v-if="showGoodsListSkeleton">
      <md-skeleton
        class="skeleton-item"
        v-for="item in 5"
        :key="item"
        avatar
        title
        :row="2"
        :loading="showGoodsListSkeleton"
      ></md-skeleton>
    </div>
    <!-- 商品列表 -->
    <div
      class="goods-list-wrap"
      :class="{noFilter: pageType === 'slide'}"
      v-show="goodsListData.total_count > 0"
    >
      <md-scroll-view
        :ref="`tab${tabId}_scrollView`"
        :scrolling-x="false"
        @refreshing="onPullingDownRefresh"
        @end-reached="onPullingUp"
      >
        <md-scroll-view-refresh
          slot="refresh"
          slot-scope="{ scrollTop, isRefreshActive, isRefreshing }"
          :scroll-top="scrollTop"
          :is-refreshing="isRefreshing"
          :is-refresh-active="isRefreshActive"
        ></md-scroll-view-refresh>
        <div class="goods-list" :class="{hasPadding: colNum > 1}">
          <template v-if="colNum === 1">
            <SingleGoodsItem
              :key="`${goodsItem.goodsId}_${index}`"
              v-for="(goodsItem, index) in goodsListData.data"
              :item="goodsItem"
              :channel="channel"
            />
          </template>
          <template v-if="colNum > 1">
            <MultiGoodsItem
              :style="{width: `${98 / colNum}%`, marginRight: `${(index + 1) % colNum === 0 ? '0' : `${2/(colNum -1)}%`}`}"
              :key="`${goodsItem.goodsId}_${index}`"
              v-for="(goodsItem, index) in goodsListData.data"
              :item="goodsItem"
              :channel="channel"
            />
          </template>
        </div>
        <md-scroll-view-more
          slot="more"
          :is-finished="!isLoadingGoodsList && !goodsListData.loadMore"
        ></md-scroll-view-more>
      </md-scroll-view>
    </div>
    <md-result-page
      style="margin-top:-2rem"
      type="empty"
      text="暂无商品"
      v-show="!isLoadingGoodsList && !goodsListData.loadMore && goodsListData.total_count === 0"
    ></md-result-page>
  </div>
</template>

<script>
import { getPageData } from '@/utils/help'
import FilterView from '@/components/filterView'
import SingleGoodsItem from '@/components/singleGoodsItem'
import MultiGoodsItem from '@/components/multiGoodsItem'
import { ScrollView, ScrollViewRefresh, ScrollViewMore, Skeleton, ResultPage } from 'mand-mobile'
export default {
  name: 'subTabPage',
  components: {
    FilterView,
    SingleGoodsItem,
    MultiGoodsItem,
    [Skeleton.name]: Skeleton,
    [ResultPage.name]: ResultPage,
    [ScrollView.name]: ScrollView,
    [ScrollViewRefresh.name]: ScrollViewRefresh,
    [ScrollViewMore.name]: ScrollViewMore,
  },
  props: {
    curTabId: {
      type: Number,
      default: -1,
    },
    tabId: {
      type: Number,
      default: -1,
    },
    pageType: {
      type: String,
      default: 'slide' // slide:轮播图商品列表, cate:分类商品列表
    },
    pageId: {
      type: String,
      default: '0' // 广告ID或二级分类ID
    },
    colNum: {
      type: Number,
      default: 1 // 商品列表默认是单列显示
    },
    channel: {
      type: String,
      default: 'tbk'
    }
  },
  data() {
    return {
      isInit: false,
      scrollVM: null, // 滚动器
      offsetTop: 0, // 滚动的距离
      showGoodsListSkeleton: true,
      isLoadingGoodsList: false,
      sort: '', // 排序方式
      goodsListData: {
        currentPage: 1,
        pageSize: 20,
        total_count: 0,
        loadMore: true,
        data: [],
      },
    }
  },
  mounted() {
    this.scrollVM = this.$refs[`tab${this.tabId}_scrollView`]
  },
  activated() {
    if (this.curTabId === this.tabId) {
      this.$_setScrollPosition()
    }
  },
  deactivated() {
    if (this.curTabId === this.tabId) {
      this.offsetTop = this.scrollVM.getOffsets().top
    }
  },
  methods: {
    /**
     * 设置滚动距离
     */
    $_setScrollPosition() {
      this.scrollVM.reflowScroller()
      this.$nextTick(() => {
        if (this.offsetTop > 0) {
          this.scrollVM.scrollTo(0, this.offsetTop, false)
        }
      })
    },
    /**
     * 滚动到某位置
     */
    scroll2Pos(posY) {
      if (this.scrollVM) {
        this.scrollVM.reflowScroller()
        this.$nextTick(() => {
          this.scrollVM.scrollTo(0, posY, false)
        })
      }
    },
    /**
     * 初始化
     */
    init() {
      this.isInit = true
      this.resetListData()
      this.fetchGoodsList(1)
    },
    /**
     * 重置列表数据
     */
    resetListData() {
      this.isLoadingGoodsList = false
      this.offsetTop = 0
      this.sort = ''
      this.goodsListData.currentPage = 1
      this.goodsListData.pageSize = 10
      this.goodsListData.total_count = 0
      this.goodsListData.loadMore = true
      this.goodsListData.data = []
      if (this.$refs.filterView) {
        this.$refs.filterView.init()
      }
      this.resetScroll()
    },
    /**
     * 重置滚动器
     */
    resetScroll() {
      if (this.scrollVM) {
        this.scrollVM.scrollTo(0, 0, false)
      }
    },
    /**
     * 下拉刷新
     */
    onPullingDownRefresh() {
      this.fetchGoodsList(1, true)
    },
    /**
     * 加载更多
     */
    onPullingUp() {
      if (this.goodsListData.loadMore) {
        this.fetchGoodsList(this.goodsListData.currentPage + 1)
      }
    },
    /**
     * 更改排序方式
     */
    handleChangeSort(sort) {
      this.sort = sort
      this.resetScroll()
      this.fetchGoodsList(1)
    },
    /**
     * 商品列表
     * @isPullingDownRefresh 是否为下拉刷新
     */
    fetchGoodsList(currentPage, isPullingDownRefresh) {
      if (this.isLoadingGoodsList) return
      this.isLoadingGoodsList = true
      if (currentPage === 1) {
        this.showGoodsListSkeleton = true
      }
      let promise
      if (this.pageType === 'slide') {
        promise = this.$http[this.channel].slideGoodsList(this.pageId, this.sort, currentPage, 20)
      } else {
        promise = this.$http[this.channel].cateGoodsList(this.pageId, this.tabId, this.sort, currentPage, 20)
      }
      promise
        .then(res => {
          this.goodsListData = getPageData(currentPage, this.goodsListData, res)
          if (isPullingDownRefresh) {
            // 下拉刷新
            this.scrollVM.finishRefresh()
          }
          this.scrollVM.finishLoadMore() // 重置加载更多
          this.showGoodsListSkeleton = false
          this.isLoadingGoodsList = false
          this.$nextTick(() => {
            this.scrollVM.reflowScroller()
          })
        })
        .catch(() => {
          this.showGoodsListSkeleton = false
          this.isLoadingGoodsList = false
        })
    },
  }
}
</script>

<style lang="scss" scoped>
.component-subTabPage {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  .skeleton-list {
    padding: 0.88rem 0.3rem;
  }
  .goods-list-wrap {
    position: absolute;
    top: 0.72rem;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    background-color: #f6f6f6;
    &.noFilter {
      top: 0;
    }
    .goods-list.hasPadding {
      padding: 0.08rem 0.12rem;
    }
  }
}
</style>
